import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT, REGISTER_REQUEST, REGISTER_SUCCESS, REGISTER_FAILURE, FINAL_REGISTER_REQUEST, FINAL_REGISTER_SUCCESS, FINAL_REGISTER_FAILURE,SHOW_PARENTAL_SCREEN,SHOW_PARENTAL_SUCCESS,SHOW_PARENTAL_RESEND_EMAIL,SHOW_MOBILE_VERIFIED,RESEND_OTP,SET_DEFAULT,SHOW_PARENTAL_RESEND_REQUEST,TOST_MESSAGE,SELF_EMAIL_VERIFICATION,REQUEST_SELF_EMAIL_VERIFICATION,FINAL_REGISTER_COMPLETION } from '../actions/actionTypes';

let user = localStorage.getItem('userDetails');
// const initialState = user ? { loggedIn: true, user } : {showRegScreen:true,showOtpScreen:false,showParentalScreen:false,firstStep:false,regUser:{},logid:0,mobileOTPError:'',emailOTPError:'',registerDone:false,isParental:false,showParentalSuccessScreen:false,openTost:false,tostMsg:'',mobileVerified:false,selfEmailVerification:false};
const initialState = {showRegScreen:true,showOtpScreen:false,showParentalScreen:false,firstStep:false,regUser:{},logid:0,mobileOTPError:'',emailOTPError:'',registerDone:false,isParental:false,showParentalSuccessScreen:false,openTost:false,tostMsg:'',mobileVerified:false,selfEmailVerification:false,registerComplete:false};

export default function authentication(state = initialState, action) {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {
                loggingIn: true,
                user: action.user,
                showParentalSuccessScreen:false,
                mobileVerified:false,
                openTost:false,
                tostMsg:'',
                emailOTPError:'',
                mobileOTPError:'',
                
            };
        case LOGIN_SUCCESS:
            return {
                loggedIn: true,
                user: action.user,
                userMaster:action.userMaster,
                userDetails:action.userDetails,
                dataForCookie:action.dataForCookie,
                showParentalSuccessScreen:false,
                mobileVerified:false,
                openTost:false,
                tostMsg:'',
                emailOTPError:'',
                mobileOTPError:'',
            };
        case LOGIN_FAILURE:
            return {
                ...state,
                showRegScreen:true,
                showOtpScreen:false,
                showParentalScreen:false,
            };
        case LOGOUT:
            return {};
        case REGISTER_REQUEST:
            return {
                ...state,
                showRegScreen:true,
                showOtpScreen:false,
                showParentalScreen:false,
                logid:0,
                firstStep:false,
                regUser:{},
                openTost:false,
                tostMsg:'',
                emailOTPError:'',
                mobileOTPError:'',
            };
        case REGISTER_SUCCESS:
            return {
                ...state,
                showRegScreen:false,
                showOtpScreen:true,
                showParentalScreen:false,
                logid:action.logid,
                firstStep:true,
                regUser:action.user,
                openTost:false,
                tostMsg:'',
            };
        case REGISTER_FAILURE:
            return {
                ...state,
                showRegScreen:true,
                showOtpScreen:false,
                showParentalScreen:false,
                logid:0,
                firstStep:false,
                regUser:{},
                registerComplete:false
            };
        case FINAL_REGISTER_REQUEST:
            return {
                ...state,
                emailOTPError:'',
                mobileOTPError:'',
                oprnTost:false,
                tostMsg:'',
            };
        case FINAL_REGISTER_SUCCESS:
            return {
                ...state,
                registerDone:true,
                userData:action.user,
                isParental:action.isParent,
                openTost:false,
                tostMsg:'',
                emailOTPError:'',
                mobileOTPError:'',
            };
        case FINAL_REGISTER_FAILURE:
            return {
                ...state,
                emailOTPError:action.error.emailError,
                mobileOTPError:action.error.mobileError,
                openTost:false,
                tostMsg:'',
            };
    case SHOW_PARENTAL_SCREEN:
            return {
                ...state,
                showRegScreen:false,
                showOtpScreen:false,
                showParentalScreen:true,
                showParentalSuccessScreen:false,
                resendEmailSuccess:false,
                openTost:false,
                tostMsg:'',
                mobileVerified:false,
            };
        case SHOW_PARENTAL_SUCCESS:
        return {
            ...state,
            showParentalSuccessScreen:true,
            resendEmailSuccess:false,
            mobileVerified:false,
        };
        case SHOW_PARENTAL_RESEND_REQUEST:
            return {
                ...state,
                openTost:action.openTost,
                tostMsg:action.tostMsg,
            };
        case SHOW_PARENTAL_RESEND_EMAIL:
            return {
                ...state,
                openTost:action.openTost,
                tostMsg:action.tostMsg,
            };
        case SHOW_MOBILE_VERIFIED:
            return {
                ...state,
                mobileVerified:true,
                openTost:false,
                tostMsg:'',
                isMobileVerified:true,
              
            }; 
            case RESEND_OTP:
            return {
                ...state,
                openTost:action.openTost,
                tostMsg:action.tostMsg,
                emailOTPError:'',
                mobileOTPError:'',
            };  
            case SET_DEFAULT:
                return {
                    ...state,
                    isMobileVerified:action.mobileVerified,
                    isParentVerified:action.parentVerified,
                    isparentRequestSent:action.isparentRequestSent,
                    openTost:false,
                    tostMsg:'',
                   
                }; 
                case REQUEST_SELF_EMAIL_VERIFICATION:
                    return {
                        ...state,
                        selfEmailVerification:false,
                        openTost:false,
                        tostMsg:'',
                        emailOTPError:'',
                       
                    };
                case SELF_EMAIL_VERIFICATION:
                    return {
                        ...state,
                        selfEmailVerification:true,
                        openTost:false,
                        tostMsg:'',
                        emailOTPError:'',
                        registerBy:action.registerBy,
                       
                    };
                case TOST_MESSAGE:
                    return {
                        ...state,
                        openTost:action.openTost,
                        tostMsg:action.tostMsg,
                       
                    };      
                    case FINAL_REGISTER_COMPLETION:
                        return {
                            ...state,
                            registerComplete:true,
                            userData:action.user
                            
                        };
        default:
            return state
    }
}